import type {
  ComparatorsByType,
  Condition,
  DateFunctionsByType,
  Field
} from '@pega/cosmos-react-condition-builder';

export const demoFields: Field[] = [
  {
    id: 'employeeId',
    primary: 'Employee ID',
    type: 'TEXT',
    possibleValues: [
      'Customer Service',
      'Engineering',
      'Facilities',
      'Finance',
      'HR',
      'IT',
      ' Sales '
    ]
  },
  {
    id: 'details',
    primary: 'Details',
    items: [
      {
        id: 'details.firstName',
        primary: 'First Name',
        type: 'TEXT'
      },
      {
        id: 'details.lastName',
        primary: 'Last Name',
        type: 'TEXT',
        possibleValues: () => {
          return new Promise(resolve => {
            setTimeout(() => {
              resolve([
                'Value 1',
                'Value 2',
                'Value 3',
                'Value 4',
                'Value 5',
                'Value 6',
                'Value 7'
              ]);
            }, 5000);
          });
        }
      },
      { id: 'details.gender', primary: 'Gender', type: 'TEXT' },
      {
        id: 'details.age',
        primary: 'Age',
        type: 'INTEGER'
      },
      {
        id: 'details.profileDetails',
        primary: 'Profile Details',
        items: [
          {
            id: 'details.profileDetails.experience',
            primary: 'Experience (yrs)',
            type: 'INTEGER'
          },
          {
            id: 'details.profileDetails.department',
            primary: 'Department',
            type: 'TEXT',
            possibleValues: [
              'Customer Service',
              'Engineering',
              'Facilities',
              'Finance',
              'HR',
              'IT',
              'Sales'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'salary',
    primary: 'Salary',
    type: 'DECIMAL'
  },
  { id: 'hireDate', primary: 'Hire Date', type: 'DATE_ONLY' },
  { id: 'dateOfBirth', primary: 'Date of Birth', type: 'DATE_ONLY' },
  {
    id: 'technicalDetails',
    primary: 'Technical details',
    items: [
      {
        id: 'technicalDetails.shiftStartTime',
        primary: 'Shift start time',
        type: 'TIME_ONLY'
      },
      {
        id: 'technicalDetails.shiftEndTime',
        primary: 'Shift end time',
        type: 'TIME_ONLY'
      },
      {
        id: 'technicalDetails.lastActivityAt',
        primary: 'Last activity at',
        type: 'DATE_TIME'
      },
      {
        id: 'technicalDetails.nextPasswordReset',
        primary: 'Next password reset',
        type: 'DATE_TIME'
      }
    ]
  },
  { id: 'isSeniorCitizen', primary: 'Is Senior Citizen', type: 'BOOLEAN' },
  { id: 'isRemoteEmployee', primary: 'Is Remote Employee', type: 'BOOLEAN' },
  {
    id: 'createOperator',
    primary: 'Create operator',
    type: 'TEXT',
    parameters: [
      {
        id: 'currentOperator',
        primary: 'Current operator'
      },
      {
        id: 'manager',
        primary: 'Manager'
      }
    ],
    possibleValues: ['Value 1', 'Value 2', 'Value 3', 'Value 4', 'Value 5', 'Value 6', 'Value 7']
  },
  {
    id: 'organization',
    primary: 'Organization',
    type: 'TEXT',
    parameters: [
      {
        id: 'currentOrganization',
        primary: 'Current organization'
      }
    ]
  },
  {
    id: 'workgroup',
    primary: 'Workgroup',
    type: 'TEXT',
    parameters: [
      {
        id: 'currentWorkgroup',
        primary: 'Current workgroup'
      }
    ],
    possibleValues: [
      { id: 'v1', primary: 'Value 1' },
      { id: 'v2', primary: 'Value 2' },
      { id: 'v3', primary: 'Value 3' },
      { id: 'v4', primary: 'Value 4' },
      { id: 'v5', primary: 'Value 5' },
      { id: 'v6', primary: 'Value 6' },
      { id: 'v7', primary: 'Value 7' }
    ]
  },
  {
    id: 'invalidField',
    primary: 'Invalid Field',
    type: 'TEXT',
    possibleValues: () => {
      return new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error());
        }, 5000);
      });
    }
  }
];

export const demoCondition: Condition = {
  AND: [
    {
      condition: {
        lhs: {
          field: 'technicalDetails.lastActivityAt'
        },
        comparator: 'EQ',
        rhs: {
          value: '2021-08-13T14:30'
        }
      }
    },
    {
      NOT: {
        OR: [
          {
            condition: {
              lhs: { field: 'details.profileDetails.experience' },
              comparator: 'GTE',
              rhs: { value: 10 }
            }
          },
          {
            condition: {
              lhs: { field: 'isRemoteEmployee' },
              comparator: 'IS_TRUE'
            }
          }
        ]
      }
    }
  ]
};

export const demoComparators: ComparatorsByType[] = [
  { type: 'TEXT', comparators: ['EQ', 'NEQ'] },
  { type: 'DECIMAL', comparators: ['GT', 'GTE', 'LT', 'LTE'] },
  { type: 'INTEGER', comparators: ['GT', 'GTE', 'LT', 'LTE'] },
  { type: 'BOOLEAN', comparators: ['IS_TRUE', 'IS_FALSE'] }
];

export const demoDateFunctions: DateFunctionsByType = {
  DATE_TIME: [
    'YEARS',
    'QUARTERS',
    'MONTHS',
    'WEEKS',
    'DAYS',
    'HOURS',
    'MINUTES',
    'SECONDS',
    'MONTHS_OF_YEAR',
    'DAYS_OF_MONTH',
    'DAYS_OF_WEEK',
    'HOURS_OF_DAY'
  ],
  DATE_ONLY: [
    'YEARS',
    'QUARTERS',
    'MONTHS',
    'WEEKS',
    'MONTHS_OF_YEAR',
    'DAYS_OF_MONTH',
    'DAYS_OF_WEEK'
  ]
};
